/**
 * Retrieves the value of a specified key from an object, with type safety.
 *
 * @typeParam T - The type of the object.
 * @typeParam K - The key of the object, constrained to the keys of T.
 * @param obj - The object from which to retrieve the value.
 * @param key - The key whose value should be retrieved from the object.
 * @returns The value associated with the specified key in the object.
 *
 * @example
 * ```typescript
 * const user = { name: "Alice", age: 30 };
 * const userName = getKeyValue(user, "name"); // "Alice"
 * ```
 */
export const getKeyValue = <T, K extends keyof T>(obj: T, key: K): T[K] => obj[key];
